<app-receipt
  [display_columns]="displayedColumns"
  [staged_receipts]="staged_receipts"
  [sse_name]="sse_name"
  [upload_field_text]="'receipt.uploadAccountReceipt' | translate"
  [validation_schema]="validation_s"
  [upload_handler]="client_proc"
  [lookupPermanent]="lookup_permanent"
  [callme]="search_through_receipts"
>
</app-receipt>
